import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { MapPin } from "lucide-react";

// Use public folder path for LCP image to enable preloading in HTML
const heroImage = "/hero-education.jpg";

export function Hero() {
  return (
    <section className="relative pt-20 md:pt-24 overflow-hidden" aria-labelledby="hero-heading">
      <div className="absolute inset-0 bg-gradient-to-b from-accent/50 to-background z-0" />
      
      <div className="container relative z-10 py-12 md:py-20 lg:py-28">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="flex flex-col gap-6 animate-fade-in-up">
            <Badge variant="secondary" className="w-fit flex items-center gap-2 px-4 py-2 text-sm bg-secondary text-secondary-foreground">
              <MapPin className="h-4 w-4" aria-hidden="true" />
              Now serving Essex
            </Badge>
            
            <h1 id="hero-heading" className="text-4xl md:text-5xl lg:text-6xl font-display font-bold leading-tight text-secondary">
              Build skills.{" "}
              <span className="text-gradient-primary">Boost employability.</span>
            </h1>
            
            <p className="text-lg md:text-xl text-muted-foreground max-w-lg">
              Improve your English and Maths to access better jobs. Practical Level 1–2 courses tailored to your goals.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 mt-2">
              <Button asChild size="lg" className="bg-gradient-hero shadow-button hover:shadow-lg transition-all text-lg px-8">
                <a href="mailto:info@upgradeskills.org">Message us</a>
              </Button>
              <Button asChild variant="outline" size="lg" className="text-lg px-8 border-secondary text-secondary hover:bg-secondary hover:text-secondary-foreground">
                <a href="#services">View courses</a>
              </Button>
            </div>

            <div className="flex items-center gap-6 mt-4 text-sm text-muted-foreground">
              <span className="flex items-center gap-2">
                <span className="h-2 w-2 rounded-full bg-primary" aria-hidden="true" />
                Reliable
              </span>
              <span className="flex items-center gap-2">
                <span className="h-2 w-2 rounded-full bg-primary" aria-hidden="true" />
                Friendly
              </span>
              <span className="flex items-center gap-2">
                <span className="h-2 w-2 rounded-full bg-primary" aria-hidden="true" />
                Affordable
              </span>
            </div>
          </div>

          <div className="relative animate-scale-in" style={{ animationDelay: "0.2s" }}>
            <div className="relative rounded-2xl overflow-hidden shadow-card">
              <img
                src={heroImage}
                alt="Adult learners studying together in a modern classroom"
                className="w-full h-auto object-cover aspect-[4/3]"
                loading="eager"
                fetchPriority="high"
                width={789}
                height={592}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-secondary/20 to-transparent" />
            </div>
            <div className="absolute -bottom-4 -left-4 bg-card rounded-xl p-4 shadow-card border border-border">
              <p className="text-2xl font-display font-bold text-primary">20+</p>
              <p className="text-sm text-muted-foreground">Years experience</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}